import { clearSupplier } from '../State/supplier';

export default () => async (dispatch) => {
  dispatch(clearSupplier());
}
